import { ButtonStyled } from '@nike/nike-design-system-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { invitationsActions } from './actions';

const StartInvitationButton = () => {
  const dispatch = useDispatch();

  return (
    <ButtonStyled
      onClick={() => {
        dispatch({ type: invitationsActions.startInvitationProcess.name });
      }}
      type='button'
    >
      <TranslatedCopy id='userManagement.button.add' />
    </ButtonStyled>
  );
};

export default StartInvitationButton;
